import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

function Faq() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);
  const faqItems = t('Faq.items', { returnObjects: true });

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white dark:bg-slate-950 py-16">
      {/* En-tête de la section */}
      <div className="text-left pb-12 px-6 lg:px-20">
        <h6 className="text-xl font-bold text-blue-600 mb-4">{t('Faq.sectionTitle')}</h6>
        <h3 className="text-4xl font-bold text-black dark:text-white mb-2">{t('Faq.title')}</h3>
        <p className="text-gray-600 dark:text-gray-400">{t('Faq.subtitle')}</p>
      </div>

      {/* Contenu FAQ */}
      <div className="container mx-auto flex flex-col lg:flex-row items-start px-6 lg:px-20">
        {/* Image (si tu veux en mettre une) */}
        <div className="lg:w-1/2 w-full h-auto mr-12 mb-10 lg:mb-0">
          <img src="/images/about.png" alt="FAQ" className="w-full h-auto rounded-lg shadow" />
        </div>

        {/* Questions accordéon */}
        <div className="lg:w-1/2 w-full">
          {faqItems.map((item, index) => (
            <div className="relative mb-4" key={index}>
              <button
                className="w-full p-4 text-left font-semibold text-blue-600 border-b border-gray-300 flex justify-between items-center"
                onClick={() => toggleAccordion(index)}
              >
                {item.title}
                <FontAwesomeIcon
                  icon={openIndex === index ? faMinus : faPlus}
                  className="text-sm text-blue-600"
                />
              </button>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === index ? 'max-h-screen' : 'max-h-0'
                }`}
              >
                <div className="p-4 text-gray-700 dark:text-gray-300 text-sm">
                  {item.content}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faq;
